/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates.
 * Licensed under The Universal Permissive License (UPL), Version 1.0
 * as shown at https://oss.oracle.com/licenses/upl/
 * @ignore
 */

import { styles } from './themes/ToolbarSeparatorStyles.css';
import { Separator } from '#UNSAFE_Separator';

export const ToolbarSeparator = () => {
  return (
    <span class={styles.separatorBase}>
      <Separator orientation="vertical" />
    </span>
  );
};
